import * as t from './actionTypes';

export const initialState = {
  name: '',
};

const catalogCollectionReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    /*--------------------------------------------------------------------------------------------*/
    /* Base Catalog Collection Builder Actions                                                    */
    /*--------------------------------------------------------------------------------------------*/
    case t.CHANGE_CURRENT_FIELDS:
      return { ...state, currentFields: action.currentFields };
    case t.RESET_COLLECTION_BUILDER:
      return initialState;
    case t.QUERY_HAS_CHANGED:
    case t.QUERY_HAS_CHANGED_FROM_STATE:
    case t.CHANGE_COMBINATOR:
    case t.CHANGE_QUERY_ORDER_BY:
    case t.CHANGE_QUERY_SIZE_LIMIT:
      return { ...state, collectionHasChanged: true };

    /*--------------------------------------------------------------------------------------------*/
    /* Fetch Catalog Collection Actions                                                           */
    /*--------------------------------------------------------------------------------------------*/
    case t.FETCH_COLLECTION:
      return {
        ...state,
        catalog: action.catalog,
        id: action.id,
        isFetchingCollection: action.isFetchingCollection,
      };

    case t.FETCH_COLLECTION_ERROR:
      return {
        ...state,
        error: action.error,
        collectionNotFound: action.collectionNotFound,
        isFetchingCollection: action.isFetchingCollection,
      };

    case t.FETCH_COLLECTION_RESPONSE:
      return {
        ...state,
        catalog: action.catalog,
        description: action.description,
        isFetchingCollection: action.isFetchingCollection,
        name: action.name,
      };

    /*--------------------------------------------------------------------------------------------*/
    /* Change Catalog Collection Actions                                                          */
    /*--------------------------------------------------------------------------------------------*/
    case t.CHANGE_CATALOG:
      return { ...state, catalog: action.catalog };
    case t.CHANGE_COLLECTION_DESCRIPTION:
      return {
        ...state,
        description: action.description,
        collectionHasChanged: action.collectionHasChanged,
      };
    case t.CHANGE_COLLECTION_DETAILS:
      return {
        ...state,
        catalog: action.catalog,
        description: action.description,
        name: action.name,
      };
    case t.CHANGE_COLLECTION_NAME:
      return { ...state, name: action.name, collectionHasChanged: action.collectionHasChanged };
    case t.SET_USES_SMART_RECOS:
      return { ...state, collectionHasChanged: action.collectionHasChanged };

    /*--------------------------------------------------------------------------------------------*/
    /* Create/Update Catalog Collection Actions                                                   */
    /*--------------------------------------------------------------------------------------------*/
    case t.CREATE_COLLECTION:
    case t.UPDATE_COLLECTION:
      return {
        ...state,
        id: action.id,
        isSaving: action.isSaving,
      };
    case t.CREATE_COLLECTION_ERROR:
    case t.UPDATE_COLLECTION_ERROR:
      return { ...state, isSaving: action.isSaving, error: action.error };
    case t.CREATE_COLLECTION_RESPONSE:
    case t.UPDATE_COLLECTION_RESPONSE:
      return {
        ...state,
        id: action.id,
        isSaving: action.isSaving,
        collectionHasChanged: action.collectionHasChanged,
      };

    /*--------------------------------------------------------------------------------------------*/
    /* Preview Catalog Collection Actions                                                         */
    /*--------------------------------------------------------------------------------------------*/
    case t.PREVIEW_COLLECTION:
      return { ...state, isLoadingPreview: action.isLoadingPreview };
    case t.PREVIEW_COLLECTION_ERROR:
      return { ...state, error: action.error, isLoadingPreview: action.isLoadingPreview };
    case t.PREVIEW_COLLECTION_RESPONSE:
      return {
        ...state,
        didPreviewData: action.didPreviewData,
        previewData: action.previewData,
        isLoadingPreview: action.isLoadingPreview,
      };

    /*--------------------------------------------------------------------------------------------*/
    /* Field Mappings                                                                */
    /*--------------------------------------------------------------------------------------------*/
    case t.FETCH_FIELD_MAPPING_RESPONSE:
      return {
        ...state,
        fieldMappings: action.fieldMappings,
      };

    default:
      return state;
  }
};

export default catalogCollectionReducer;
